// extracted by mini-css-extract-plugin
export default {"no-user-select":"styles_no-user-select__9I7Za","invisible-span":"styles_invisible-span__tBke9"};